<section class="maintenance">
  <div class="glow" aria-hidden="true"></div>

  <div class="mark">
    <span class="mark-ring" aria-hidden="true"></span>
    <span class="mark-card">
      <img src="assets/logo-icon.svg" alt="SpotCharge"/>
    </span>
  </div>

  <h1>{{ title() }}</h1>
  <p>{{ message() }}</p>
</section>
